import Header from "../components/Header";
import Footer from "../components/Footer";
import Spacer from "../components/Spacer";
import { Grid, makeStyles, Button } from "@material-ui/core";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useInView } from 'react-intersection-observer';

const useStyles = makeStyles({
  back: {
    backgroundColor: '#151515',
    color: "white",
    minHeight: '100vh',
    width: '100vw',
    zIndex: -2,
    overflow: "hidden",
    // filter: "blur(5px)"
  },
  back2: {
    backgroundColor: '#f5f5f5',
    color: "black",
    minHeight: '100vh',
    width: '100vw',
    zIndex: -2,
    overflow: "hidden",
    // filter: "blur(5px)"
  },
  columnCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    position:'relative',
  },
  columnStart: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'start',
    flexDirection: 'column',
    height:"100%"
  },
  bar: {
    position:"absolute",
    left:34,
    top:30,
    width:2,
    height: '350vh',
  },
  bar2: {
    position:"absolute",
    left:34,
    width:2,
    height: '300vh',
  },
  mainBox: {
    position:"relative",
    // height: '100vh',
    width: '100vw',
  },
  rowSpace: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    // flexWrap:'wrap',
  },
  partBox:{
    position:"relative",
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    // backgroundColor:"red",
    height: '60vh',
    width: '90vw',
  },
  title: {
    fontSize:60,
    lineHeight:"60px",
    fontFamily:"IExtraBold"
  },
  subTitle: {
    fontSize:30,
    lineHeight:"60px",
    fontFamily:"IExtraBold"
  },
  count: {
    fontSize:80,
    fontFamily:"Fat",
  },
  image: {
    marginRight:50,
    height: "25vw",
    width: "25vw"
  },
  imageBox: {
    // backgroundColor:"red",
    // height: "25vw",
    // width: "30vw",
  },
  pointSign: {
    position:"absolute",
    left:-52,
    top:30,
    height:28,
    width:28,
    borderRadius:"50%",
  },
  rowCenter: {
    // backgroundColor:"#2F2C37",
    // color:"white",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap:'wrap',
    position: 'relative',
},
rowStart: {
    // backgroundColor:"#2F2C37",
    // color:"white",
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap:'wrap'
},
discription: {
  width: "40vw",
  fontFamily:"Regular"
}
})

const ImageRoot = styled('img')(({ theme, open, size }) => ({
  margin: 5,
  height: size,
  width: size,
  border: "solid",
  borderRadius: "15%",
  borderWidth: 3,
  borderColor: "#dbd9d9",
  transform: "translate(0px,20px)",
  opacity: 0,
  ...(open && {
    transition: '0.5s',
    transform: "translate(0px,0px)",
    opacity: 1,
  }),
}));

const AboutPage = ({sales, nfts}) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState([]);
  const [update, setUpdate] = useState(true);

  const { ref, inView } = useInView({})

  useEffect(()=>{
    console.log(isOpen.length, nfts.length);
    if(isOpen.length < nfts.length && inView){
      setTimeout(()=>{
        let copy = isOpen;
        copy.push(true);
        setIsOpen(copy)
        setUpdate(update?false:true);
      },20);
    }
    if(!inView){
      setIsOpen([])
    }
  },[update, inView])

  return <><div className={classes.back}>
    <Header color="white" subColor="#030303" sales={sales}/>
    <Spacer height={300}/>
    <div className={classes.mainBox}>
    <div className={classes.bar} style={{backgroundColor:"white"}}/>
      <div className={classes.columnCenter}>
        <div className={classes.partBox}>
          <div className={classes.columnStart}>
          <div className={classes.pointSign} style={{ backgroundColor:"white"}}/>
          <div className={classes.title}>
            <div>Why</div>
            <div>WAGMI Music ?</div>
          </div>
          <Spacer height={15}/>
          <div className={classes.discription}>
          WAGMI Music is web3 digital agent and protect the right of artist with the power of blockchain: non-fungible-token, smart contract, and all that jazz.
          </div>
          <Spacer height={15}/>
          <div className={classes.discription}>
          We aims to help artists and creators sustainable activities that respond to the web3 era, and to improve together.
          </div>
          <Spacer height={15}/>
          <div className={classes.discription}>
          WAGMI Music はブロックチェーンの力でアーティストの権利を守る，web3音楽エージェントです．
          </div>
          <Spacer height={15}/>
          <div className={classes.discription}>
          私たちはweb3におけるアーティストとクリエイターの持続可能な音楽活動を支援し，共に成長することを目指しています．
          </div>
          </div>
          <img className={classes.image} src={'/image/image_board.webp'}/>
        </div>
      </div>
    </div>
    <Spacer height={"15vh"}/>
    </div>
    <div className={classes.back2}>
    <div className={classes.bar2} style={{backgroundColor:"black"}}/>
    <Spacer height={"15vh"}/>
    <div className={classes.mainBox}>
    <div className={classes.columnCenter}>
      <div className={classes.partBox}>
        <div className={classes.columnStart}>
        <div className={classes.pointSign} style={{ backgroundColor:"black"}}/>
        <div className={classes.count}>01</div>
        <div className={classes.subTitle}>
          <div>Deploy Music Token</div>
        </div>
        <Spacer height={20}/>
        <div className={classes.discription}>音楽NFTがブロックチェーン上に展開されると，書き込まれた音楽は自動契約によって保護され，不当な</div>
        </div>
        <div ref={ref} className={classes.imageBox}>
        {nfts.length != 0?<div className={classes.columnCenter}>
          <div className={classes.rowCenter}>
          <ImageRoot open={isOpen[8]} size={'4vw'} src={nfts[8].image}/>
          <ImageRoot open={isOpen[14]} size={'4vw'} src={nfts[14].image}/>
          <ImageRoot open={isOpen[10]} size={'4vw'} src={nfts[10].image}/>
          </div>
          <div className={classes.rowCenter}>
          <ImageRoot open={isOpen[4]} size={'4.5vw'} src={nfts[4].image}/>
          <ImageRoot open={isOpen[3]} size={'4.5vw'} src={nfts[3].image}/>
          <ImageRoot open={isOpen[9]} size={'4.5vw'} src={nfts[9].image}/>
          <ImageRoot open={isOpen[2]} size={'4.5vw'} src={nfts[2].image}/>
          </div>
          <div className={classes.rowCenter}>
          <ImageRoot open={isOpen[0]} size={'5vw'} src={nfts[0].image}/>
          <ImageRoot open={isOpen[6]} size={'5vw'} src={nfts[6].image}/>
          <ImageRoot open={isOpen[7]} size={'5vw'} src={nfts[7].image}/>
          <ImageRoot open={isOpen[15]} size={'5vw'} src={nfts[15].image}/>
          <ImageRoot open={isOpen[5]} size={'5vw'} src={nfts[5].image}/>
          </div>
          <div className={classes.rowCenter}>
          <ImageRoot open={isOpen[8]} size={'4.5vw'} src={nfts[8].image}/>
          <ImageRoot open={isOpen[1]} size={'4.5vw'} src={nfts[1].image}/>
          <ImageRoot open={isOpen[11]} size={'4.5vw'} src={nfts[11].image}/>
          <ImageRoot open={isOpen[12]} size={'4.5vw'} src={nfts[12].image}/>
          </div>
          <div className={classes.rowCenter}>
          <ImageRoot open={isOpen[3]} size={'4vw'} src={nfts[3].image}/>
          <ImageRoot open={isOpen[10]} size={'4vw'} src={nfts[10].image}/>
          <ImageRoot open={isOpen[2]} size={'4vw'} src={nfts[2].image}/>
          </div>
        </div>
        :<></>}
        </div>
      </div>
      <Spacer height={"30vh"}/>
      <div className={classes.partBox}>
        <div className={classes.columnStart}>
        <div className={classes.pointSign} style={{ backgroundColor:"black"}}/>
        <div className={classes.count}>02</div>
        <div className={classes.subTitle}>
          <div>Funding Token</div>
        </div>
        <Spacer height={20}/>
        <div>hogehoge</div>
        </div>
        <img className={classes.image} src={'/image/waveform2.webp'}/>
      </div>
      <Spacer height={"30vh"}/>
      <div className={classes.partBox}>
        <div className={classes.columnStart}>
        <div className={classes.pointSign} style={{ backgroundColor:"black"}}/>
        <div className={classes.count}>03</div>
        <div className={classes.subTitle}>
          <div>Sharing Token Economy</div>
        </div>
        <Spacer height={20}/>
        <div>hogehoge</div>
        </div>
        <img className={classes.image} src={'/image/waveform2.webp'}/>
      </div>
    </div>
    </div>
    <Spacer height={100}/>
    <Footer/>
    </div>
  </>;
}

export default AboutPage;